/** TODO: documentation */
export interface Coordinates {
  x: number
  y: number
}
export namespace Coordinates {
  /**
   * Retrieves the coordinates of the clicked element based on received Click
   * Event
   */
  export function from(event: Event): Coordinates {
    if (!event.target) {
      // If there is no Html Element found then return default coordinates
      return {
        x: 0,
        y: 0,
      }
    }
    const domRectangle =
      // Casted because we know it is an Html Element, but it is not
      // recognized as such from the mouse click event
      (event.target as unknown as HTMLElement).getBoundingClientRect()
    return {
      x: domRectangle.left,
      y: domRectangle.top,
    }
  }
}
